<script>
  import { LayerCake, ScaledSvg, Html } from 'layercake';
  import AxisX from './AxisX.html.svelte';
  import MaxMin from './MaxMin.svelte';
  import { tweened } from 'svelte/motion';
  import { format } from '../lib/utils';
  import Line from './Line.svelte';
  import Months from './Months.svelte';
  import Avg from './Avg.svelte';
  export let icon;
  export let name;
  export let unit;
  export let valueUnit;
  export let months;
  export let avg;
  export let animated = false;
  export let showMonthsTop = false;
  export let showMonthsBottom = false;


  const yDomain = tweened(undefined, { duration: animated ? 400 : 0 });

  $: data = months.map((d, i) => ({ x: i+0.5, y: d }));
  $: extra = (months[0] + months[11])/2;
  $: data.push({x: 12, y: extra});
  $: data.unshift({x: 0, y: extra});
  $: min = Math.min(...months);
  $: max = Math.max(...months);

  $: yDomain.set([max, min]);


  const frmt = format(2, true);


  function formatMaxMin(d) {
    return frmt(d.y) + valueUnit;
  }

</script>

<div class="sitem">
  <div class="sitem__meta">
    <div class="sitem__icon" style:background-image={`url('${PATH}/food-icons-min/${icon}.svg')`}></div>
    <div class="sitem__name">{name}</div>
    <div class="sitem__unit">{unit}</div>
  </div>
  <div class="sitem__graph">

    <LayerCake
      ssr={true}
      percentRange={true}
      padding={{ right: 0, bottom: 0, left: 0, top: 0 }}
      x="x"
      y="y"
      data={data}
      yDomain={$yDomain}
      yRange={[25, 75]}
      xDomain={[0, 12]}
    >
      <Html>
        <AxisX ticks={[0,1,2,3,4,5,6,7,8,9,10,11,12]} tickLabels={false} />
        {#if showMonthsTop}
          <Months bottom={false} />
        {/if}
        {#if showMonthsBottom}
          <Months bottom={true} />
        {/if}
      </Html>
      <ScaledSvg>
        <Avg {avg} />
        <Line smooth={true} stroke="#2a2a2a" {animated}/>
      </ScaledSvg>
      <Html>
        <MaxMin formatLabel={formatMaxMin} />
      </Html>
    </LayerCake>
  </div>
</div>

<style>

  .sitem {
    font-size: 16px;
    line-height: 20px;
    position: relative;
    display: flex;
    align-items: center;
  }

  .sitem__meta {
    padding-left: 45px;
    flex: 0 0 120px;
    position: relative;
  }

  .sitem__name {
    font-weight: bold;
    display: block;
  }
  .sitem__unit {
    display: block;
  }
  .sitem__icon {
    position: absolute;
    /*top: -15px;*/
    top: -3px;
    left: 0;
    width: 40px;
    height: 40px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .sitem__graph {
    flex: 1 0 1px;
    position: relative;
    height: 80px;
  }

  @media (max-width: 480px) {
    .sitem {
      font-size: 14px;
      line-height: 17px;
    }

    .sitem__meta {
      padding-left: 45px;
      flex: 0 0 100px;
    }

    .sitem__graph {
      height: 60px;
    }
  }
</style>
